(function () {
    var $button;
    var shopifyProductId;

    function cartItemsInUrlParameters() {
        var url = new URL(window.location);
        var cartItems = url.searchParams.get('cartItems');
        return cartItems?.split(',') ?? [];
    }

    function removeCartItemId(aCartItemKey) {
        return new Promise(function (resolve) {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: JSON.stringify({
                    quantity: 0,
                    id: aCartItemKey,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            }).done(resolve);
        });
    }

    function delay(aTime, aData) {
        return new Promise(function (resolve) {
            setTimeout(function() {
                resolve(aData);
            }, aTime);
        });
    }

    function saveConfiguration() {
        return expivi.saveConfiguration(512, 512)
    }

    function createVariant(savedBundle) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                type: 'POST',
                url: '/apps/configurator',
                data: JSON.stringify({
                    configuration: savedBundle.configured_products,
                    productId: shopifyProductId
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            }).done(function(createResult) {
                createResult.configuredProduct = savedBundle.configured_products[0];
                resolve(createResult);
            }).fail(reject);
        });
    }

    function addToCart(createResult) {
        return new Promise(function (resolve, reject) {
            let addJsResponse = {
                quantity: 1,
                id: createResult.variant_id,
                properties: createResult.options,
            };

            // If there is a custom behaviour
            if (createResult.useCustomAddJs) {
                if (createResult.themeCallback) {
                    window[createResult.themeCallback](resolve, reject, addJsResponse, createResult);
                }
                // Default behaviour
            } else {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify(addJsResponse),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                }).done(resolve).fail(reject);
            }
        });
    }

    window.xpv_hooks_add_to_cart = function(context, event) {
        $button = $(context);
        shopifyProductId = $button.data('productId');

        // Disable button
        if ($button[0].hasAttribute('disabled')) {
            return false;
        }
        event.preventDefault();
        $button.attr('disabled', 'disabled');
        $button.addClass('loading');

        return Promise.resolve()
            .then(function(result) {
                return saveConfiguration(result);
            })
            .then(function(result) {
                return createVariant(result);
            })
			.then(function (result) {
                return delay(2000, result);
            })
            .then(function(result) {
                return addToCart(result)
            })
            .then(function() {
                if ($button.data('url') !== 'NONE') {
                    window.location.href = $button.data('url');
                }

                // Don't let expivi handle add to cart
                return false;
            }).catch(function (error) {
                $button.removeAttr('disabled');
                $button.removeClass('loading');
                throw error;
            });
    }
})();